
import './styles/quasar.scss'
import lang from 'quasar/lang/es.js'
import '@quasar/extras/material-icons/material-icons.css'
import Notify from 'quasar/src/plugins/Notify.js';import Dialog from 'quasar/src/plugins/Dialog.js';import Loading from 'quasar/src/plugins/Loading.js'; 
import { version } from '../package.json';

window.appVersion = version;
console.log(`%c Delmond Express - Tecnicos GAPAL v${version} `);

// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: {
    Notify,
    Dialog,
    Loading
  },
  lang: lang
}